import React, { ReactElement } from "react";
import autumnIcon from "../../../assets/images/icons/autumn.png";
import coolerMonthsIcon from "../../../assets/images/icons/coolerMonths.png";
import springIcon from "../../../assets/images/icons/spring.png";
import summerIcon from "../../../assets/images/icons/summer.png";
import winterIcon from "../../../assets/images/icons/winter.png";
import imagePlaceholder from "../../../assets/images/icons/strawberry.svg";

import {
  WineCharacteristicsContainer,
  WineCharacteristicsTitle,
  CharacteristicWrapper,
  ImageWrapper,
  CharacteristicImage,
  CharacteristicName,
  WineCharacteristics,
} from "./style";

interface Characteristics {
  id: number | null;
  name: string;
  imageSmallUrl?: string | null | undefined;
}

interface WineCharacteristicsSectionProps {
  title: string;
  characteristics?: Characteristics[];
  isSeasonsSection?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const seasonsIcons: any = {
  Autumn: autumnIcon,
  "Cooler Months": coolerMonthsIcon,
  Spring: springIcon,
  Summer: summerIcon,
  Winter: winterIcon,
};

const WineCharacteristicsSection = (
  wineSpecsRowProps: WineCharacteristicsSectionProps
): ReactElement | null => {
  const { title, characteristics, isSeasonsSection } = wineSpecsRowProps || {};
  if (!characteristics) {
    return null;
  }
  return (
    <WineCharacteristicsContainer>
      <WineCharacteristicsTitle>{title}</WineCharacteristicsTitle>
      <WineCharacteristics>
        {characteristics?.map((characteristic) => {
          const icon = isSeasonsSection
            ? seasonsIcons?.[characteristic?.name]
            : characteristic?.imageSmallUrl;
          return (
            <CharacteristicWrapper key={characteristic?.id}>
              <ImageWrapper>
                <CharacteristicImage src={icon ?? imagePlaceholder} isPlaceholderImage={!icon} />
              </ImageWrapper>
              <CharacteristicName>{characteristic?.name}</CharacteristicName>
            </CharacteristicWrapper>
          );
        })}
      </WineCharacteristics>
    </WineCharacteristicsContainer>
  );
};

export default WineCharacteristicsSection;
